import { createQueryKeys } from '@lukemorales/query-key-factory';

import { getData } from '../utils/functional/fp';

import { getAgencyAncestors } from '../api/agencies.api';

export const agencies = createQueryKeys('agencies', {
  ancestors: (agencyId: string) => ({
    queryKey: [{ agencyId }],
    queryFn: () => getAgencyAncestors({ params: { agencyId } }).then(getData),
  }),
});
